import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import IconSprite from '@/components/Icon/IconSprite.vue';
import ErrorBoundary from '@/components/ErrorBoundary.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_RouterView = _resolveComponent("RouterView");
            return (_openBlock(), _createBlock(ErrorBoundary, null, {
                default: _withCtx(() => [
                    _createVNode(IconSprite),
                    _createVNode(_component_RouterView)
                ]),
                _: 1
            }));
        };
    }
});
